<template>
  <div class="container">
    <div class="page">
      <div class="header">
        <div class="left">
          Order submitted successfully, please pay as soon as possible! Order
          No.：{{ detail.order_no }}
        </div>
        <div class="right">
          Amount payable <span class="money">${{ detail.total_price }}</span>
        </div>
      </div>
      <div class="content">
        <div class="img-wrap">
          <img
            v-if="pay_type == 'paypal'"
            src="../../assets/images/icon_paypal.png"
            alt=""
            class="icon"
          />
          <img
            v-if="pay_type == 'credit'"
            src="../../assets/images/icon_credit.png"
            alt=""
            class="icon"
          />
          <span>{{ pay_type == "paypal" ? "PayPal" : "Credit Pay" }}</span>
        </div>

        <div class="credit_pay">
          <template v-if="pay_type == 'credit'">
            <h2 class="padding-tb-sm">Please fill your bank code info.</h2>
            <div class="flex align-center justify-between padding-tb-sm">
              <span class="text-sm">Card Holder Name</span>
              <input class="input" v-model="payment_info.card_holder_name" />
            </div>
            <div class="flex align-center justify-between padding-tb-sm">
              <span class="text-sm">Card Number</span>
              <input class="input" v-model="payment_info.card_number" />
            </div>
            <div class="flex align-center justify-between padding-tb-sm">
              <span class="text-sm">Card Expiry Date (MM/YY)</span>
              <div class="flex align-center justify-center" style="width: 40%">
                <Select
                  v-model="payment_info.month"
                  style="width: 100px; height: 40px"
                >
                  <Option
                    :value="i"
                    v-for="(i, index) in months"
                    :key="index"
                    >{{ i }}</Option
                  >
                </Select>
                <span>/</span>
                <Select
                  v-model="payment_info.year"
                  style="width: 100px; height: 40px"
                >
                  <Option :value="i" v-for="(i, index) in years" :key="index">{{
                    i
                  }}</Option>
                </Select>
              </div>
            </div>
            <div class="flex align-center justify-between padding-tb-sm">
              <span class="text-sm">Card Security Code (CSC)</span>
              <input
                class="input"
                maxlength="3"
                v-model="payment_info.card_security_code"
              />
            </div>
          </template>

          <div class="flex align-center justify-center">
            <button class="btn-submit" @click="onOrderPay">
              Confirm Payment
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Profile, OrderDetail, PayOrder, PayExecute } from "@/api/index.js";
import axios from "axios";
import { mapState } from "vuex";
import dayjs from "dayjs";

export default {
  name: "CashDesk",
  components: {},
  data() {
    return {
      uuid: "",
      pay_type: "",
      detail: {},
      payment_info: {
        card_holder_name: "",
        card_number: "",
        month: "",
        year: "",
        card_security_code: "",
      },
      months: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"],
      years: [],
    };
  },
  computed: {
    ...mapState(["setting"]),
  },
  methods: {
    async getProfile() {
      return Profile().then((response) => {
        return response;
      });
    },
    onOrderPay() {
      const { uuid, pay_type, payment_info } = this;
      const param = {};
      param.uuid = uuid;
      param.pay_type = pay_type;
      if (pay_type == "credit") {
        if (
          !payment_info.card_holder_name ||
          !payment_info.card_number ||
          !payment_info.card_security_code ||
          !payment_info.month ||
          !payment_info.year
        ) {
          return;
        }
        param.payment_info = payment_info;
      }
      if(pay_type == 'paypal') {

        param.payment_info = {
          return_url:`${location.protocol}//${location.host}/order/cashdesk?uuid=${this.uuid}&pay_type=paypal`,
          cancel_url:`${location.protocol}//${location.host}/order/checkout?uuid=${this.uuid}`
          //  return_url:`https://draft2real.com/order/cashdesk?uuid=${this.uuid}&pay_type=paypal`,
          //  cancel_url:`https://draft2real.com/order/checkout?uuid=${this.uuid}`
        }
      }


      PayOrder(param)
        .then((response) => {
          if (pay_type == "paypal") {
            window.open(response.data.url,'_self');
          } else {
            this.$router.replace({
              name: "PayResult",
              query: { uuid: this.uuid },
            });
          }
        })
        .catch((e) => {
          this.$layer.msg(e.msg);
        });
    },
  },
  mounted() {
    this.uuid = this.$route.query.uuid;
    this.pay_type = this.$route.query.pay_type;
    if (this.$route.query.uuid) {
      OrderDetail({
        uuid: this.$route.query.uuid,
      }).then((response) => {
        this.detail = response.data;
      });
    }
    if (this.$route.query.token) {
      PayExecute({
					orderId:this.$route.query.token,
					payer_id:this.$route.query.PayerID,
			}).then((response) => {
        this.$router.replace({
            name: "PayResult",
            query: { uuid: this.uuid },
          });
      });
    }
    axios.all([this.getProfile()]).then(axios.spread(() => {}));
    let nowYear = Number(dayjs(new Date()).format("YY"));
    let years = [];
    for (var i = nowYear; i < nowYear + 15; i++) {
      years.push(i);
    }
    this.years = years;
  },
};
</script>

<style scoped lang="scss">
.container {
  background: #f6f7fa;
  padding-top: 30px;
  padding-bottom: 30px;
  .page {
    width: 1500px;
    margin: 0 auto;
    padding: 0 70px;
    background: white;
    border-radius: 10px 10px 10px 10px;
    .header {
      height: 92px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #dbdbdb;
      color: #333;
      .right {
        .money {
          font-size: 24px;
          color: #fa3d5a;
        }
      }
    }

    .content {
      .img-wrap {
        display: flex;
        align-items: center;
        font-size: 26px;
        margin: 25px 0;
        .icon {
          width: 32px;
          height: 32px;
          margin-right: 10px;
        }
      }

    }
  }
}
.credit_pay {
  width: 500px;
  .padding-tb-sm {
    padding: 5px 0;
  }
  .input {
    width: 200px;
    height: 30px;
    line-height: 30px;
    border: 1px solid #d9d9d9;
    border-radius: 5px;
    padding: 0 10px;
    outline: none;
    font-size: 14px;
  }
  .btn-submit {
    margin: 40px 0 20px 0px;
    width: 150px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #fa3d5a;
    color: white;
    border-radius: 6px;
    cursor: pointer;
    border: none;
  }
}
</style>
